module.exports = __webpack_public_path__ + "media/categories/1068-926ed3a4.svg";